<!-- Profile Details Starts -->
@let currentUser = authService.currentUser;
@if (avatar()) {
  <p-avatar
    test-id="profile-details"
    class="tw:cursor-pointer tw:m-2"
    style="--p-avatar-width: 2.4rem; --p-avatar-height: 2.4rem"
    [ngStyle]="{
      'background-color': currentUser()?.name || '' | uniqueRgbColor,
      color: 'var(--p-surface-0)',
    }"
    [label]="profilePic()"
    pTooltip="My Account"
    tooltipPosition="right"
    (click)="profilePopover.toggle($event)"
    shape="circle" />
} @else {
  <div
    test-id="profile-details"
    class="tw:flex tw:w-full tw:items-center tw:gap-2 tw:border-t tw:border-surface tw:bg-(--p-content-background) tw:px-3 tw:py-3 tw:text-left tw:transition tw:duration-200 tw:cursor-pointer"
    (click)="profilePopover.toggle($event)">
    <p-avatar
      style="--p-avatar-width: 2.5rem; --p-avatar-height: 2.5rem; --p-avatar-font-size: 1rem"
      class="tw:shrink-0"
      [ngStyle]="{
        'background-color': currentUser()?.name || '' | uniqueRgbColor,
        color: 'var(--p-surface-0)',
      }"
      [label]="profilePic()"
      shape="circle" />
    <div class="tw:w-full tw:min-w-0">
      <div class="tw:truncate">
        {{ currentUser()?.visibleName }}
      </div>
      <div class="tw:truncate tw:text-sm tw:text-muted-color">
        {{ currentUser()?.email }}
      </div>
    </div>
  </div>
}
<p-menu
  #profilePopover
  [popup]="true"
  appendTo="body"
  [model]="profileMenu()">
  <ng-template
    pTemplate="item"
    let-item>
    @if (item.disabled) {
      <a
        class="p-menu-item-link p-disabled"
        data-pc-section="itemlink"
        [attr.test-id]="'profile-menu-item-' + item.label">
        <ng-container *ngTemplateOutlet="linkContent" />
      </a>
    } @else if (item.url) {
      <a
        pRipple
        class="p-menu-item-link"
        data-pc-section="itemlink"
        [attr.test-id]="'profile-menu-item-' + item.label"
        [attr.href]="item.url"
        [target]="item.target">
        <ng-container *ngTemplateOutlet="linkContent" />
      </a>
    } @else if (item.routerLink) {
      <a
        pRipple
        class="p-menu-item-link"
        data-pc-section="itemlink"
        [attr.test-id]="'profile-menu-item-' + item.label"
        [routerLink]="item.routerLink"
        [routerLinkActive]="['p-menu-item-link-active']">
        <ng-container *ngTemplateOutlet="linkContent" />
      </a>
    } @else {
      <a
        pRipple
        class="p-menu-item-link"
        data-pc-section="itemlink"
        [attr.test-id]="'profile-menu-item-' + item.label"
        (click)="item.command ? item.command() : null">
        <ng-container *ngTemplateOutlet="linkContent" />
      </a>
    }

    <ng-template #linkContent>
      @if (item.icon) {
        <span
          [ngClass]="item.icon"
          class="p-menu-item-icon"
          data-pc-section="itemicon"></span>
      }
      <span
        class="p-menu-item-label"
        data-pc-section="itemlabel">
        {{ item.label }}
      </span>
    </ng-template>
  </ng-template>
  <ng-template
    pTemplate="submenuheader"
    let-submenu>
    <div class="tw:flex tw:items-center tw:justify-between tw:gap-2">
      <span>{{ submenu.label }}</span>
      @if (submenu.label === 'Profile' && profileApiKey.apiKey()) {
        <button
          type="button"
          test-id="profile-copy-api-key"
          class="tw:flex tw:items-center tw:gap-1.5 tw:rounded-full tw:border tw:border-surface tw:px-2 tw:py-1 tw:text-xs tw:font-medium tw:text-muted-color tw:cursor-pointer"
          [disabled]="profileApiKey.copyStatus() === 'isLoading'"
          (click)="$event.stopPropagation(); copyApiKey()">
          <i
            class="pi tw:text-xs"
            [ngClass]="{
              'pi-copy': profileApiKey.copyStatus() === 'isIdle',
              'pi-spin pi-spinner-dotted': profileApiKey.copyStatus() === 'isLoading',
              'pi-check': profileApiKey.copyStatus() === 'isSuccess',
              'pi-exclamation-triangle': profileApiKey.copyStatus() === 'isError',
            }"></i>
          <span>
            {{
              profileApiKey.copyStatus() === 'isLoading'
                ? 'Copying'
                : profileApiKey.copyStatus() === 'isSuccess'
                  ? 'Copied'
                  : profileApiKey.copyStatus() === 'isError'
                    ? 'Copy failed'
                    : 'Copy API key'
            }}
          </span>
        </button>
      }
    </div>
  </ng-template>
  <ng-template pTemplate="start">
    <div class="tw:flex tw:items-center tw:gap-3 tw:border-b tw:border-surface tw:p-3 tw:w-2xs">
      <p-avatar
        class="tw:shrink-0"
        style="--p-avatar-width: 3rem; --p-avatar-height: 3rem; --p-avatar-font-size: 1.25rem"
        [ngStyle]="{
          'background-color': currentUser()?.name || '' | uniqueRgbColor,
          color: 'var(--p-surface-0)',
        }"
        [label]="profilePic()"
        shape="circle" />
      <div class="tw:flex tw:flex-col tw:w-full tw:min-w-0">
        <div
          class="tw:truncate tw:font-medium tw:text-lg"
          [pTooltip]="currentUser()?.visibleName"
          tooltipPosition="bottom">
          {{ currentUser()?.visibleName }}
        </div>
        <div
          class="tw:truncate tw:text-sm tw:text-muted-color"
          [pTooltip]="currentUser()?.email"
          tooltipPosition="bottom">
          {{ currentUser()?.email }}
        </div>
      </div>
    </div>

    <div class="tw:flex tw:flex-col tw:gap-1 tw:p-2 tw:border-b tw:border-surface">
      <p-select-button
        fluid
        [options]="[
          { label: 'Light', icon: 'pi pi-sun', value: false },
          { label: 'Dark', icon: 'pi pi-moon', value: true },
        ]"
        [ngModel]="themeService.isDark()"
        (onChange)="themeService.toggleDark()"
        [unselectable]="false"
        size="small"
        [autofocus]="false">
        <ng-template
          pTemplate="item"
          let-option>
          <i [ngClass]="option.icon"></i>
          <span>{{ option.label }}</span>
        </ng-template>
      </p-select-button>
    </div>
  </ng-template>
</p-menu>
